import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { SheetsListStateService } from '@modules/sheets/services/sheets-list-state.service';
import { SheetsService } from '@modules/sheets/services/sheets.service';
import { Sheet } from '@modules/sheets/types/sheet';
import { SheetsFilters } from '@modules/sheets/types/sheets-filters';
import { SheetsListState } from '@modules/sheets/types/sheets-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-sheets-section',
  templateUrl: './sheets-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...SheetsListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeSheetsSectionComponent
  extends KnowledgeStitchSectionComponent<Sheet, SheetsFilters>
  implements OnInit
{
  protected readonly listStateService = inject(SheetsListStateService, { self: true });
  protected readonly stitchService = inject(SheetsService);

  public override ngOnInit(): void {
    this.state = new SheetsFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: SheetsListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new SheetsFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
